import { BASE_API_URL, WEBDB_S3_URL } from '../envs.js';
import { getLanguageCode } from '../i18n.js';
import { isSeasonCode } from '../layers/layerHelpers.js';
import { isDateBetween } from '../utils.js';
import { maintenanceStatus$ } from '../stores/store-main.js';
export class Addressable {
    constructor(data) {
        if (typeof data.get === 'function') {
            data = data;
            this.addressName = data.get('name');
            this.addressName2 = data.get('name_2');
            this.addressStreet = data.get('street');
            this.addressZip = data.get('zip');
            this.addressCity = data.get('place');
            this.addressPhone = data.get('tel');
            this.addressMobile = data.get('mobile');
            this.addressEmail = data.get('email');
            this.addressUrl = data.get('url1_link');
            this.addressUrlText = data.get('url1_text');
            this.urlBookingLink = data.get('url2_link');
            this.urlBookingText = data.get('url2_text');
        }
        else {
            Object.assign(this, data);
        }
    }
}
export class PlacesBase extends Addressable {
    constructor(data) {
        super(data);
        if (typeof data.get === 'function') {
            data = data;
            const bigGallery = data.get('photo_gallery_big');
            this.id = data.get('id');
            this.title = data.get('title');
            this.abstract = data.get('abstract');
            this.photo = data.get('foto');
            this.description = data.get('description');
            this.gallery = data
                .get('photo_gallery')
                .map((src, indx) => {
                return {
                    src: src,
                    srcBig: bigGallery[indx] || src,
                };
            });
        }
        else {
            Object.assign(this, data);
        }
    }
}
export async function fetchAdminMessage() {
    const propagatedParams = typeof document !== 'undefined' ? document.location.search : '';
    const response = await fetch(`${WEBDB_S3_URL}/banners/${getLanguageCode()}/banners.json${propagatedParams}`)
        .then((r) => (r.status >= 300 ? Promise.reject('Error') : r.json()))
        .catch((r) => {
        return [];
    });
    if (!response.length)
        return null;
    switch (response[0].titleBackgroundColor?.color) {
        case '#8CE99A':
            response[0].type = 'success';
            break;
        case '#FFC078':
            response[0].type = 'warning';
            break;
        case '#FFA8A8':
            response[0].type = 'error';
            break;
        default:
            response[0].type = undefined;
    }
    return response[0];
}
export async function updateMaintenanceStatus() {
    try {
        const response = await fetch(`${BASE_API_URL}/api/4/loginConfig`);
        if (response.status === 200) {
            maintenanceStatus$.next(await response.json());
        }
    }
    catch {
        console.error('Could not update mstatus');
    }
}
export async function postFeedback(feedback) {
    const formData = new FormData();
    Object.entries(feedback).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            formData.append(key, value instanceof Boolean ? value.toString() : value);
        }
    });
    return fetch(`${BASE_API_URL}/api/5/feedback`, {
        method: 'POST',
        body: formData,
    });
}
export async function fetchSeason() {
    try {
        const propagatedParams = typeof document !== 'undefined' ? document.location.search : '';
        const response = await fetch(`${WEBDB_S3_URL}/season_dates/en/season_dates.json${propagatedParams}`);
        const json = await response.json();
        const dates = json
            .filter((s) => isSeasonCode(s.title.toLowerCase()))
            .map((s) => {
            return {
                code: s.title.toLowerCase(),
                startDate: new Date(s.startDate),
            };
        });
        if (isDateBetween(dates[0].startDate, dates[1].startDate, new Date())) {
            return dates[0].code;
        }
        else {
            return dates[1].code;
        }
    }
    catch (e) {
        console.error(e);
        return getDefaultSeasonFallback();
    }
}
function getDefaultSeasonFallback() {
    const summerStart = new Date('1970-03-15');
    const summerEnd = new Date('1970-11-21');
    if (isDateBetween(summerStart, summerEnd, new Date())) {
        return 'summer';
    }
    else {
        return 'winter';
    }
}
//# sourceMappingURL=api-common.js.map